import {mxConstraintHandler, mxUtils} from "mxgraph-js";

class HCLTreeMxConstraintHandler extends mxConstraintHandler {

  // Snaps to fixed points
  intersects(icon: any, mouse: any, source: boolean, existingEdge: boolean): boolean {
    return (!source || existingEdge) || mxUtils.intersects(icon.bounds, mouse);
  }
}

export default HCLTreeMxConstraintHandler;
